import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    // Check if user is admin
    const adminStatus = localStorage.getItem('isAdmin') === 'true' && 
                        localStorage.getItem('userRole') === 'admin';
    setIsAdmin(adminStatus);

    // Listen for storage changes (in case user logs in/out in another tab)
    const handleStorageChange = () => {
      const newAdminStatus = localStorage.getItem('isAdmin') === 'true' && 
                             localStorage.getItem('userRole') === 'admin';
      setIsAdmin(newAdminStatus);
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="navbar">
      <div className="container">
        <div className="navbar-brand">
          <Link to="/">
            <img src="/eagle-logo-transparent.png" alt="Eagles Refuge Academy Logo" className="logo" />
          </Link>
        </div>

        <button
          className="navbar-toggle"
          onClick={toggleMenu}
          aria-label="Toggle navigation"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <div className={`navbar-menu ${isMenuOpen ? 'active' : ''}`}>
          <ul className="navbar-nav">
            <li><Link to="/" onClick={() => setIsMenuOpen(false)}>Home</Link></li>
            <li><Link to="/about" onClick={() => setIsMenuOpen(false)}>About</Link></li>
            <li><Link to="/apply" onClick={() => setIsMenuOpen(false)}>Apply</Link></li>
            <li><Link to="/contact" onClick={() => setIsMenuOpen(false)}>Contact</Link></li>
            <li className="dropdown">
              <span>Portals</span>
              <ul className="dropdown-menu">
                <li><Link to="/student-portal" onClick={() => setIsMenuOpen(false)}>Student Portal</Link></li>
                <li><Link to="/teacher-portal" onClick={() => setIsMenuOpen(false)}>Teacher Portal</Link></li>
                <li><Link to="/parent-portal" onClick={() => setIsMenuOpen(false)}>Parent Portal</Link></li>
                {isAdmin && (
                  <li><Link to="/admin" onClick={() => setIsMenuOpen(false)}>Admin Dashboard</Link></li>
                )}
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
